import { ArrowUpRight } from "lucide-react"
import { MarketingLayout } from "@/components/marketing/MarketingLayout"
import { MarketingMetadata } from "@/components/marketing/MarketingMetadata"
import type { MarketingPageProps } from "@/types/marketing"

const PRIVACY_COPY = {
  hr: [
    {
      title: "Voditelj obrade i kontakt",
      body: (
        <>
          Voditelj obrade je Zmile d.o.o., Petra Preradovića 1, 43000 Bjelovar,
          Hrvatska, OIB 05972180818. Za opća pitanja i zahtjeve povezane s
          osobnim podacima javite se na <a href="mailto:info@zmile.hr">info@zmile.hr</a>.
        </>
      ),
    },
    {
      title: "Podaci koje nam šaljete",
      body: (
        <>
          Zahtjev za provjeru web-stranice sadrži adresu web-stranice, ime
          kontaktne osobe, poslovnu e-adresu, naziv tvrtke, potvrdu da ste
          pročitali ovu obavijest i opcionalni opis problema. Zahtjev za
          konzultacije sadrži ime, poslovnu e-adresu, naziv tvrtke, željeni
          datum i vrijeme, opis onoga što želite poboljšati ili automatizirati,
          potvrdu obavijesti te opcionalnu adresu web-stranice. Kada nam se
          javite izravno e-poštom, obrađujemo podatke koje dobrovoljno pošaljete.
          Nemamo opći kontaktni obrazac i ne tražimo privolu za newsletter.
        </>
      ),
    },
    {
      title: "Tehnički i zaštitni podaci",
      body: (
        <>
          Poslužitelj može bilježiti IP adresu, vrijeme zahtjeva, traženu
          adresu, vrstu preglednika i tehničke pogreške. Obrasci bilježe i
          tehničke podatke potrebne za CSRF zaštitu, ograničenje učestalosti,
          provjeru vremena ispunjavanja i otkrivanje automatiziranih prijava.
          Koristimo ih radi sigurnosti, stabilnosti i dijagnostike, a ne za
          oglašavanje.
        </>
      ),
    },
    {
      title: "Svrhe i pravne osnove",
      body: (
        <>
          Podatke koristimo kako bismo procijenili i odgovorili na vaš upit,
          pripremili i potvrdili razgovor, poslali potrebne transakcijske
          poruke, zaštitili stranicu i vodili nužnu poslovnu evidenciju. Obrada
          se temelji na poduzimanju koraka na vaš zahtjev prije moguće suradnje,
          legitimnom interesu za sigurnu i učinkovitu poslovnu komunikaciju te
          zakonskim obvezama gdje su primjenjive. Potvrda uz obrazac nije
          marketinška ni newsletter privola.
        </>
      ),
    },
    {
      title: "Transakcijska e-pošta putem Postmarka",
      body: (
        <>
          Postmark koristimo za slanje potvrda, obavijesti o zahtjevima i
          poruka o potvrđenim konzultacijama. Postmark zato obrađuje adresu
          pošiljatelja i primatelja, sadržaj poruke te tehničke podatke o
          dostavi. Ne koristimo te podatke za newsletter. Više o pružatelju
          pročitajte u <a href="https://postmarkapp.com/privacy-policy" rel="noreferrer" target="_blank">Postmark pravilima privatnosti<ArrowUpRight className="marketing-inline-icon" aria-hidden="true" /></a>.
        </>
      ),
    },
    {
      title: "PostHog analitika, kolačići i snimke sesija",
      body: (
        <>
          Na javnim marketinškim stranicama koristimo PostHog EU Cloud sa
          standardnim trajnim kolačićima, automatskim bilježenjem interakcija
          (autocapture) i snimkama sesija. PostHog može bilježiti posjećene
          stranice, klikove, navigaciju, tehničke podatke uređaja i preglednika,
          približno vrijeme te mrežne podatke koje dopušta postavka EU projekta.
          Obrada IP adrese ovisi o provjerenim postavkama bilježenja IP adresa
          u tom projektu.
          Ne učitavamo ga na prijavi, obnovi lozinke, administraciji ni drugim
          autentificiranim stranicama. Vrijednosti svih polja za unos su
          maskirane u snimkama, a parametri upita uklanjaju se iz zabilježenih
          adresa stranica i mrežnih zahtjeva. Više pročitajte u <a href="https://posthog.com/privacy" rel="noreferrer" target="_blank">PostHog pravilima privatnosti<ArrowUpRight className="marketing-inline-icon" aria-hidden="true" /></a>.
        </>
      ),
    },
    {
      title: "Povezivanje upita s analitikom",
      body: (
        <>
          Pri slanju obrasca možemo spremiti trenutni anonimni PostHog
          identifikator uz Lead kao njegov Analytics Identity. Time ovlašteni
          administrator može povezati upit s ponašanjem i snimkama iste
          anonimne sesije prije i nakon slanja. Ime, e-adresu, naziv tvrtke,
          adresu web-stranice, poruku, interni identifikator zapisa i druge
          vrijednosti obrasca ne šaljemo PostHogu kao osobna svojstva.
        </>
      ),
    },
    {
      title: "Drugi izvršitelji i primatelji",
      body: (
        <>
          Podatke obrađuju pružatelji hostinga i baze podataka koji pokreću
          stranicu, Postmark za e-poštu i PostHog za javnu analitiku.
          Podacima mogu pristupiti ovlaštene osobe Zmilea te savjetnici ili
          tijela kada je to nužno radi zakonske obveze ili zaštite pravnih
          zahtjeva. Podatke ne prodajemo.
        </>
      ),
    },
    {
      title: "Beta kolačići i čuvanje",
      body: (
        <>
          Beta izdanje nema banner za pristanak na kolačiće. PostHog možete
          ograničiti postavkama preglednika, brisanjem kolačića ili alatom za
          blokiranje, a obrasci i navigacija nastavljaju raditi bez analitike.
          Tijekom bete Lead zapisi imaju ručno brisanje, ali nema automatizirani
          rok brisanja ili anonimizacije. Podatke čuvamo dok su potrebni za
          odgovor i odnos koji je uslijedio, sigurnost, moguće pravne zahtjeve i
          obvezne poslovne evidencije. Razdoblja u Postmarku i PostHogu ovise i
          o postavkama tih usluga.
        </>
      ),
    },
    {
      title: "Vaša prava",
      body: (
        <>
          Možete zatražiti pristup, ispravak, brisanje, ograničenje obrade ili
          prijenos podataka te uložiti prigovor kada je primjenjivo. Zahtjev
          pošaljite na <a href="mailto:info@zmile.hr">info@zmile.hr</a>. Imate
          pravo podnijeti pritužbu Agenciji za zaštitu osobnih podataka ili
          drugom nadležnom nadzornom tijelu.
        </>
      ),
    },
  ],
  en: [
    {
      title: "Controller and contact",
      body: (
        <>
          The controller is Zmile d.o.o., Petra Preradovića 1, 43000 Bjelovar,
          Croatia, Croatian tax number (OIB) 05972180818. For general questions
          or personal-data requests, email <a href="mailto:info@zmile.hr">info@zmile.hr</a>.
        </>
      ),
    },
    {
      title: "Information you submit",
      body: (
        <>
          A request for a Website Review contains the website URL, contact name,
          work email, company name, acknowledgement that you read this notice,
          and optional context about the problem. A Consultation Request contains
          the contact name, work email, company name, preferred date and time,
          what you would like to improve or automate, the notice
          acknowledgement, and an optional website URL. If you email us
          directly, we process the information you choose to send. We do not
          provide a general-contact form or ask for newsletter consent.
        </>
      ),
    },
    {
      title: "Technical and protective data",
      body: (
        <>
          The server may record an IP address, request time, requested URL,
          browser type, and technical errors. Forms also record technical data
          needed for CSRF protection, rate limiting, completion-time checks,
          and automated-submission detection. We use this information for
          security, stability, and diagnostics, not advertising.
        </>
      ),
    },
    {
      title: "Purposes and legal bases",
      body: (
        <>
          We use the data to assess and answer your enquiry, prepare and confirm
          a conversation, send necessary transactional messages, protect the
          website, and maintain required business records. Processing is based
          on steps you ask us to take before a possible engagement, our
          legitimate interest in secure and effective business communication,
          and legal obligations where applicable. The form acknowledgement is
          not marketing or newsletter consent.
        </>
      ),
    },
    {
      title: "Transactional email through Postmark",
      body: (
        <>
          We use Postmark to send acknowledgements, request notifications, and
          confirmed-consultation messages. Postmark therefore processes sender
          and recipient addresses, message content, and technical delivery
          data. We do not use this data for newsletters. Read the <a href="https://postmarkapp.com/privacy-policy" rel="noreferrer" target="_blank">Postmark privacy policy<ArrowUpRight className="marketing-inline-icon" aria-hidden="true" /></a>.
        </>
      ),
    },
    {
      title: "PostHog analytics, cookies, and session replay",
      body: (
        <>
          We use PostHog EU Cloud on public marketing pages with standard
          persistent cookies, autocapture, and session replay. PostHog may
          record pages visited, clicks, navigation, device and browser details,
          approximate time, and network data allowed by the EU project
          settings. IP-address processing depends on the verified IP-capture
          settings in that project. It does not load on Login, password, admin,
          or other authenticated pages. All input values are masked in replay, and query
          strings are stripped from captured page and network URLs. Read the <a href="https://posthog.com/privacy" rel="noreferrer" target="_blank">PostHog privacy policy<ArrowUpRight className="marketing-inline-icon" aria-hidden="true" /></a>.
        </>
      ),
    },
    {
      title: "Linking an enquiry to analytics",
      body: (
        <>
          When a form is submitted, we may store the current anonymous PostHog
          identifier on the Lead as its Analytics Identity. This lets an
          authorised administrator connect the enquiry with the same anonymous
          session's behavior and replays before and after submission. We do not
          send the name, email, company, website URL, message, internal record
          ID, or other form values to PostHog as person properties.
        </>
      ),
    },
    {
      title: "Other processors and recipients",
      body: (
        <>
          Data is processed by the hosting and database providers running the
          website, Postmark for email, and PostHog for public analytics.
          Authorised Zmile personnel and advisers or authorities may receive
          data when necessary for a legal obligation or legal claim. We do not
          sell personal data.
        </>
      ),
    },
    {
      title: "Beta cookies and retention",
      body: (
        <>
          The beta does not display a cookie-consent banner. You can limit
          PostHog through browser controls, by clearing cookies, or with a
          blocker; forms and navigation continue to work without analytics.
          During beta, Lead records support manual deletion but have no
          automated deletion period or anonymisation schedule. We keep data
          while needed for the response and any resulting relationship,
          security, potential legal claims, and mandatory business records.
          Retention in Postmark and PostHog also depends on those services'
          project settings.
        </>
      ),
    },
    {
      title: "Your rights",
      body: (
        <>
          You may request access, correction, deletion, restriction, or data
          portability and may object to processing where applicable. Email <a href="mailto:info@zmile.hr">info@zmile.hr</a>.
          You also have the right to complain to the Croatian Personal Data
          Protection Agency or another competent supervisory authority.
        </>
      ),
    },
  ],
} as const

export default function MarketingPrivacy(props: MarketingPageProps) {
  return (
    <>
      <MarketingMetadata
        alternateUrls={props.alternate_urls}
        canonicalUrl={props.canonical_url}
        description={props.description}
        locale={props.locale}
        noindex={props.noindex}
        socialImageUrl={props.social_image_url}
        title={props.title}
      />
      <MarketingLayout
        consultationHref={props.consultation_href}
        currentPageKey={props.page_key}
        footer={props.footer}
        homeHref={props.home_href}
        languageSwitch={props.language_switch}
        locale={props.locale}
        navigation={props.navigation}
      >
        <article className="privacy-page">
          <header>
            <h1 className="type-marketing-hero-display">{props.heading}</h1>
            <p className="type-marketing-lead">{props.summary}</p>
            <small>
              {props.locale === "hr"
                ? "Ažurirano: 1. kolovoza 2026."
                : "Updated: 1 August 2026."}
            </small>
          </header>
          <div className="privacy-sections">
            {PRIVACY_COPY[props.locale].map((section, index) => (
              <section key={section.title}>
                <span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span>
                <div>
                  <h2 className="type-marketing-list-display">{section.title}</h2>
                  <p className="type-marketing-prose">{section.body}</p>
                </div>
              </section>
            ))}
          </div>
        </article>
      </MarketingLayout>
    </>
  )
}
